import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCookie } from "../../util/cookie/cookies";

export const SubPageNavBox = () => {
    const lang = getCookie('HYUNDAILANG')
    const location = useLocation()
    const navigate = useNavigate()
    const path = location.pathname.split('/')
    const [data, setData] = useState<any>([])
    const handleTransPage = (url : string) => {
        if(url !== location.pathname){navigate(url)}
    }
    useEffect(()=>{
        switch(path[1]){
            case 'about' : setData(aboutNaviData); break;
            case 'liebherr' : setData(liebherrNaviData); break;
            case 'hyundai' : setData(hyundaiNaviData); break;
            case 'prCenter' : setData(promotionNaviData); break;
            case 'contact' : setData(contactNaviData); break;
        }
    }, [location])
    return(
        <>
        <div className="btnBox">
            <div className={`btn_${data?.length}`}>
                {data.map((list:any,index:number) => (
                    <button key={index} className={list.name===path[2]?'active':''} onClick={()=>handleTransPage(list.url)}>
                        {lang === 'kr'? list.title_kr : list.title_en}
                    </button>
                ))} 
            </div>
        </div> 
        </>
    )
}

export const aboutNaviData = [
    {name : 'overView', title_kr : '회사개요', title_en : 'Company Overview', url : '/about/overView'},
    {name : 'history',title_kr : '연혁', title_en : 'History', url : '/about/history'},
    {name : 'exportStatus',title_kr : '수출현황', title_en : 'Export Status', url : '/about/exportStatus'},
    {name : 'business',title_kr : '사업장소개', title_en : 'Location', url : '/about/business'},
]

export const liebherrNaviData = [
    {name : 'marineEngine', title_kr : '선박용 엔진', title_en : 'Marine Engine', url : '/liebherr/marineEngine'},
    {name : 'generatorEngine', title_kr : '발전기 엔진', title_en : 'Generator Engine', url : '/liebherr/generatorEngine'},
]

export const hyundaiNaviData = [
    {name : 'marineEngine', title_kr : '선박용 엔진', title_en : 'Marine Engine', url : '/hyundai/marineEngine'},
    {name : 'generatorEngine', title_kr : '발전기 엔진', title_en : 'Generator Engine', url : '/hyundai/generatorEngine'},
]

export const promotionNaviData = [
    {name : 'news', title_kr : '보도자료', title_en : 'Press Release', url : '/prCenter/news?type=ALL'},
    {name : 'technology', title_kr : '기술자료', title_en : 'Tech Release', url : '/prCenter/technology?page=1'},
    {name : 'promotion', title_kr : '홍보자료', title_en : 'Promotion Release', url : '/prCenter/promotion/catalogue?page=1'},
]

export const contactNaviData = [
    {name : 'inquiry', title_kr : '문의하기', title_en : 'Contact Us', url : '/contact/inquiry'},
    {name : 'faq', title_kr : 'FAQ', title_en : 'FAQ', url : '/contact/faq'},
]